module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/appeal_top_main-1fcf17442d477b59a8a736ad08b85ad0.jpg";